import { render, staticRenderFns } from "./Info.vue?vue&type=template&id=6837c855&scoped=true&"
import script from "./Info.vue?vue&type=script&lang=js&"
export * from "./Info.vue?vue&type=script&lang=js&"
import style0 from "../../../style/vxe-table-style.less?vue&type=style&index=0&lang=less&"
import style1 from "./Info.vue?vue&type=style&index=1&id=6837c855&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6837c855",
  null
  
)

export default component.exports